import React from "react";

const NumberInput = ({
  value,
  onChange,
  placeholder,
  autoFocus = false,
  onKeyPress,
}) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Only allow positive integers
    if (inputValue === "" || /^\d+$/.test(inputValue)) {
      onChange(inputValue);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onKeyPress?.(e);
    }
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      placeholder={placeholder}
      className="px-2 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent w-20"
      autoFocus={autoFocus}
    />
  );
};

export default NumberInput;
